import { useCallback, useSyncExternalStore } from "react";
import { isPeriodPreset, type PeriodPreset } from "../utils/period";

export const DEFAULT_PERIOD_PRESET: PeriodPreset = "thisMonth";

const PRESET_EVENT = "skud:report-preset";

/** `?preset=` ni o'qiydi; yo'q yoki noma'lum qiymat → standart. */
export function parsePeriodPreset(search: string): PeriodPreset {
	const qiymat = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search).get(
		"preset"
	);

	return isPeriodPreset(qiymat) ? qiymat : DEFAULT_PERIOD_PRESET;
}

function subscribe(onChange: () => void): () => void {
	window.addEventListener("popstate", onChange);
	window.addEventListener(PRESET_EVENT, onChange);

	return () => {
		window.removeEventListener("popstate", onChange);
		window.removeEventListener(PRESET_EVENT, onChange);
	};
}

/**
 * Markaz davri URL da (`?preset=`) — sahifa yangilanganda va havola
 * ulashilganda saqlanadi.
 *
 * ⚠️ `useReportFilters` naqshi (History API + maxsus hodisa):
 * `routeTree.tsx` muzlatilgan va `/reports` da `validateSearch` yo'q.
 * `replaceState` — har tanlov tarixga yozilmasin. Boshqa query
 * parametrlari SAQLANADI.
 */
export function usePeriodPreset(): {
	preset: PeriodPreset;
	setPreset: (next: PeriodPreset) => void;
} {
	const search = useSyncExternalStore(
		subscribe,
		() => window.location.search,
		() => ""
	);

	const setPreset = useCallback((next: PeriodPreset) => {
		const params = new URLSearchParams(window.location.search);

		params.set("preset", next);
		window.history.replaceState(null, "", `${window.location.pathname}?${params.toString()}`);
		window.dispatchEvent(new Event(PRESET_EVENT));
	}, []);

	return { preset: parsePeriodPreset(search), setPreset };
}
